// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
	production: false,
	APP_MULTIMARCA: false,
	URL_MASTER: "https://test.master.cursalab.io",

	//**MARCA PROPIA
	SERVICE_BASE: "https://gestiona.test2.cursalab.co/api/",
	SERVICE_BASE_GESTOR: "https://gestiona.test2.cursalab.co/",
	SERVICE_BASE_REST: "https://gestiona.test2.cursalab.co/api/rest/",
	SERVICE_BASE_AUTH: "https://gestiona.test2.cursalab.co/api/auth/",
	URL_BASE: "https://test2.cursalab.co/",
	URL_REPORTE: "https://reportes.main.cursalab.co/",

	SERVICE_BASE_REST_MASTER: "https://test.master.cursalab.io/api/",

	// //**url de tiendas
	APP_PLAYSTORE: "",
	APP_ID_PLAYSTORE: "",
	APP_ID_IOS: "",

	// //**versiones
	APP_VERSION_IOS: "0.0",
	APP_VERSION_ANDROID: "0.0",
	WEB_VERSION: "0.0.1",

	//*****google analytics ID test
	GA_TRACKING_ID:"G-FVFVVW99KV",

	recaptcha:{
		siteKey: "6LeLUBAkAAAAAGIuPtfdvgzcpgAPHboYlvp1GdUf"
	},

	RUTA_ARCHIVOS: "archivos/",
	RUTA_DIPLOMA: "dnc/",
	RUTA_DESCARGAS: "dnx/",

	LOGO_APP: "assets/img/logo_color.png",
	LOGO_BY_CURSALAB: "assets/img/logo_by_cursalab.svg",
	LOGO_CURSALAB: "assets/img/logo-cursalab.svg",

	RUTA_TEMPLATE_INVITADOS:
		"https://d1rhexnbhr0x6m.cloudfront.net/inretail/plantillas/Plantilla-Importar-Invitados.xlsx",

  CUSTOM_SCHEMA: "io.cursalab.app://",
  TYPE_CLIENT: "multimarca",

  MIX_PUSHER_BACKEND_API: '',
  MIX_PUSHER_PORT: 443,
  MIX_PUSHER_TLS: true,
  MIX_PUSHER_APP_CLUSTER: 'mt1',
  REPORTS_SECRETKEY: "",
  //**GOOGLE MAPS PLATFORM
  // Key de Maps JavaScript API. La usa el mapa de la reunion de feedback
  // presencial (app-address-picker). Sin ella el campo de direccion sigue
  // funcionando como input de texto y el mapa simplemente no se muestra.
  // Restricciones de referrer que necesita la key:
  //   http://localhost:4200/*  y  https://<dominio de la marca>/*
  //   https://localhost/*      <- Android (Capacitor usa androidScheme: "https")
  //   capacitor://localhost/*  <- iOS (verificar que Cloud lo acepte)
  GOOGLE_MAPS_API_KEY: "",
  // Key aparte para el build nativo, SOLO si Cloud no acepta el referrer de iOS.
  // Vacia = se usa GOOGLE_MAPS_API_KEY en las tres plataformas.
  GOOGLE_MAPS_API_KEY_NATIVE: "",
  // Map ID de Cloud (Google Maps Platform > Map management). Lo exige
  // AdvancedMarkerElement; vacio => marcador clasico (deprecado pero funcional).
  GOOGLE_MAPS_MAP_ID: "",
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
